
export const REGEX_IP = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/(3[0-2]|[1-2][0-9]|[0-9]))$/;
export const REGEX_IP_V4 = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export function validateIP(ip, v4) {

    let isValid = undefined;
    let message = '';

    if (!v4) {
        const expression = new RegExp(REGEX_IP, 'gi');
        isValid = !!expression.test(ip);
        message = !!expression.test(ip) ? '' : 'IPv4 address can contain only 0-9 and . For example: 192.8.34.29';
    }

    if (v4) {
        const expression = new RegExp(REGEX_IP_V4, 'gi');
        isValid = !!expression.test(ip);
        message = !!expression.test(ip) ? '' : 'IPv4 address can contain only 0-9 and . For example: 192.8.34.29';
    }

    return {isValid, message}
}